import { Component, OnInit,Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-update-note-modal',
  templateUrl: './update-note-modal.component.html',
  styleUrls: ['./update-note-modal.component.scss']
})
export class UpdateNoteModalComponent implements OnInit {
  updateNotesForm!:FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private apiservice: ApiService,
    private matDialogRef: MatDialogRef<UpdateNoteModalComponent>
    ) { }

  ngOnInit(): void {
   if(this.data){
    this.formInit(this.data);
   }
  }
  formInit(data:any){
    this.updateNotesForm = new FormGroup({
      leadId: new FormControl((data.leadId || '')),
      note: new FormControl((data.note || ''), [Validators.required]),
    })
  };

  updateNote(){
    if(this.updateNotesForm.valid){
      this.apiservice.patch('admin/lead/update-lead-note/' + this.data?.noteId, this.updateNotesForm.value).subscribe((res:any)=>{
        if(res.body){
          this.apiservice.alert(res?.body?.message, 'success');
          this.matDialogRef.close('ModalClosedByApi');
        }
      }, err =>{
        this.apiservice.alert('Please try again later', 'error');
      })
    } else {
      this.updateNotesForm.markAllAsTouched();
    }
  }


}
